import ZoomIn from './src/zoom-in-combined';
export default ZoomIn;